// extracted by mini-css-extract-plugin
export default {"infoContainer":"styles_infoContainer__L8IeU","title":"styles_title__JAnkp","paragraph":"styles_paragraph__yrIA3"};